import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import togetherProduct from "../together-product/index.vue";

export default {
  name: "together-slider",
  components: {
    VueSlickCarousel,
    togetherProduct,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    rootClass: {
      type: String,
      default: "basket__popup_together",
    },
  },
  data() {
    return {
      carouselKey: 1,
      productsSlider: {
        infinite: true,
        centerPadding: "0",
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 672,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    hideSliderArrows() {
      switch (true) {
        case window.innerWidth > 672 && this.products.length >= 4:
          return true;
        case window.innerWidth < 672 && window.innerWidth > 500 && this.products.length >= 3:
          return true;
        case window.innerWidth <= 500 && this.products.length >= 2:
          return true;
        default:
          return false;
      }
    },
  },
  watch: {
    products() {
      this.carouselKey += 1;
    },
  },
  methods: {
    showNext() {
      this.$refs.productsSlider.next();
    },
    showPrev() {
      this.$refs.productsSlider.prev();
    },
  },
};
